
/* eslint-disable no-unused-vars */
const Autodesk = window.Autodesk;
import store from '@/store';
import { removeFromScene, pointerToRaycaster, createTextGl, addToScene } from '../utils/forgeUtils'
import { convexHull } from '../utils/geometryUtils'
import { disposeArea2d, drawArea2d, drawPolygon, drawLine } from '../utils/threejsUtils'
import { ForgeEquipment, ForgeScaffold, ForgeAnnotation, ForgeInspection, ForgePipeline, ForgeStructural } from './../scripts/js/forgeModels';
import { getAMISTagById } from '@/utils/amisAPIs'
import config from '../../appConfig'
const THREE = window.THREE;

class labels3dExt extends Autodesk.Viewing.Extension {
    constructor(loadedViewer, options) {
        super(loadedViewer, options);
        this.viewer = loadedViewer;
        // this.raycaster.params.PointCloud.threshold = 5;

        //image point cloud
        this.clustersTextMeshes = [];
        this.clusterHoveringAreaMesh = null;
        this.clusterPolyBorderGl = [];
        //tags cloud
        this.pointClouds = [];
        this.selectedPcInterval = null;

        this.hoveringPointCloud;
        this.cameraZ = 0;

        this.hoveringColor = 0XAD5087
        this.hoveringArea = null

        this.camera = this.viewer.impl.camera;
        this.viewType = this.isViewer2d() ? '2d' : '3d',
        this.colorCorrection = this.isViewer2d() ? 1 : 0.75;
        this.hovered = -1;
        this.selected;
        this.sceneName = 'mods-labels-3d';
        this.areas2d = [];
        this.imagesPointsCount = 0;
        this.vertexShader = `
            uniform int isViewer2d;
            uniform int isTag;
            uniform float cameraX;
            uniform float cameraY;
            uniform float cameraZ;
            uniform float scaleFactor;
            uniform float visibilityRange;
            
            attribute vec3 position3d;

            varying vec3 vColor;
            varying vec3 vPos;
            
            void main() {
                float distance = sqrt(((cameraX - position.x)*(cameraX - position.x) + (cameraY - position.y)*(cameraY - position.y) + (cameraZ - position.z)*(cameraZ - position.z)));
                
                if(isViewer2d == 1){
                    distance = sqrt(((cameraX - position3d.x)*(cameraX - position3d.x) + (cameraY - position3d.y)*(cameraY - position3d.y) + (cameraZ - position3d.z)*(cameraZ - position3d.z)));
                }

                if(visibilityRange < distance){
                    gl_PointSize = 0.0;
                    gl_Position = vec4(100.0, 100.0, 100.0, 0.0);
                    return;
                }

                vColor = color;
                vPos = position;

                vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );

                if (isViewer2d == 0) {                        
                    if(isTag == 0) {
                        gl_PointSize = 30.0 * ( 30.0 / (length(mvPosition.xyz) + 1.0) ) * scaleFactor;
                        if(gl_PointSize < 30.0) gl_PointSize = 30.0;
                    } else  {
                        gl_PointSize = 40.0 * ( 40.0 / (length(mvPosition.xyz) + 1.0) ) * scaleFactor;
                        if(gl_PointSize > 40.0) gl_PointSize = 40.0;
                    }
                } else {
                    gl_PointSize = 50.0;
                } 
                
                gl_Position = projectionMatrix * mvPosition;
            }
        `
        this.fragmentShader = `
            uniform sampler2D tex;
            uniform sampler2D hoveringTexture;
            varying vec3 vColor;
            varying vec3 vPos;
            void main() {
            if(vColor.r > 4.0 && vColor.g > 4.0 && vColor.b > 4.0)
                    gl_FragColor = texture2D(hoveringTexture, vec2((gl_PointCoord.x), 1.0-gl_PointCoord.y));
                else
                    gl_FragColor = texture2D(tex, vec2((gl_PointCoord.x), 1.0-gl_PointCoord.y));

                if (gl_FragColor.w < 0.5) discard;
            }
        `;

        this.tagsFragmentShader = `
            uniform sampler2D tex;
            uniform int isMISTag;
            uniform vec3 textureColor;
            uniform vec3 hoveringTextureColor;
            varying vec3 vColor;
            varying vec3 vPos;
            void main() {
                gl_FragColor = texture2D(tex, vec2((gl_PointCoord.x), 1.0-gl_PointCoord.y));

                
                    // vColor = (5.0, 5.0, 5.0)
                    // hover state.
                    if(vColor.r > 4.0 && vColor.g > 4.0 && vColor.b > 4.0) {
                        if (gl_FragColor.w > 0.95 && gl_FragColor.x > 0.95) {
                            gl_FragColor = vec4(hoveringTextureColor, 1.0); 
                        } else {
                            gl_FragColor = vec4(hoveringTextureColor, 0.0);
                        }
                    }
                    else {
                        // Normal Tag 
                        if (isMISTag == 0) {
                            // White area (1.0, 1.0, 1.0, 1.0) => textureColor
                            if (gl_FragColor.w > 0.95 && gl_FragColor.x > 0.95) {
                                gl_FragColor = vec4(textureColor, 1.0);
                            } else if (gl_FragColor.w > 0.95 && gl_FragColor.x < 0.01) {
                                // Black area
                                // color set to (3.0, 3.0, 3.0) => opacity 0 for middle circle => no category
                                if (vColor.r < 2.0 && vColor.g < 2.0 && vColor.b < 2.0) {
                                    gl_FragColor = vec4(vColor, 1.0);
                                } else {
                                    gl_FragColor = vec4(1.0, 0.0, 0.0, 0.0);
                                    // gl_FragColor = vec4(vColor, 0.0);
                                }
                            }
                        } else {
                            // AMIS Tag
                            if (gl_FragColor.w > 0.95 && gl_FragColor.x > 0.95) {
                                gl_FragColor = vec4(vColor, 1.0);
                            } else if (gl_FragColor.w > 0.95 && gl_FragColor.x < 0.01) {
                                gl_FragColor = vec4(1.0, 0.0, 0.0, 0.0);
                            }
                        }
                    }

                if (gl_FragColor.w < 0.5) discard;
            }
        `;
        
        var loadTexture = function(url){
            var texture = THREE.ImageUtils.loadTexture(url);
            texture.minFilter = THREE.LinearFilter;
            return texture;
        }
        this.textures = {
            pin:loadTexture(require('@/images/pin.png')),
            location2d: loadTexture(require(`@/images/2d-location.png`)),
            equipment:loadTexture(require(`@/images/Equipment.png`)),
            pipeline:loadTexture(require(`@/images/Equipment.png`)),
            structural:loadTexture(require(`@/images/Equipment.png`)),
            inspection:loadTexture(require(`@/images/Inspection.png`)),
            scaffold:loadTexture(require(`@/images/Scaffold.png`)),
            permit:loadTexture(require(`@/images/Permit.png`)),
            container:loadTexture(require(`@/images/Container.png`)),
            tagHover:loadTexture(require(`@/images/tagHover.png`)),

            cluster:loadTexture(require(`@/images/Cluster.png`)),
            faro:loadTexture(require(`@/images/Faro.png`)),
            leica:loadTexture(require(`@/images/Leica.png`)),
            gps:loadTexture(require(`@/images/Ricoh.png`)),
            geoslam:loadTexture(require(`@/images/Geoslam.png`)),

            clusterHover:loadTexture(require(`@/images/Cluster-hover.png`)),
            faroHover:loadTexture(require(`@/images/Faro-hover.png`)),
            leicaHover:loadTexture(require(`@/images/Leica-hover.png`)),
            gpsHover:loadTexture(require(`@/images/Ricoh-hover.png`)),
            geoslamHover:loadTexture(require(`@/images/Geoslam-hover.png`)),

            faro2d:loadTexture(require(`@/images/Faro-2d.png`)),
            leica2d:loadTexture(require(`@/images/Leica-2d.png`)),
            gps2d:loadTexture(require(`@/images/Ricoh-2d.png`)),
            geoslam2d:loadTexture(require(`@/images/geoslam-2d.png`)),

            faro2dHover:loadTexture(require(`@/images/Faro-hover-2d.png`)),
            leica2dHover:loadTexture(require(`@/images/Leica-hover-2d.png`)),
            gps2dHover:loadTexture(require(`@/images/Ricoh-hover-2d.png`)),
            geoslam2dHover:loadTexture(require(`@/images/geoslam-hover-2d.png`)),

        };

        let _this = this;
        let startX;
        let startY;
        let webGLDOM = this.viewer.canvas.parentElement.parentElement.parentElement;
        this.isMouseDown = false;
        this.viewer.canvas.addEventListener("mousedown", (event) => {
            _this.isMouseDown = true;
            startX = event.pageX;
            startY = event.pageY;
            store.commit('hideThumbnailPopup',_this.viewType);
        });
        webGLDOM.addEventListener("mouseup", (event) => {
            _this.isMouseDown = false;
            const delta = 6;
            const diffX = Math.abs(event.pageX - startX);
            const diffY = Math.abs(event.pageY - startY);

            if (diffX < delta && diffY < delta) {
                _this.onClick(event);
            }
        });
        webGLDOM.addEventListener("mousemove", (event) => {
            if(!_this.isMouseDown)
                _this.onMouseMove(event);
        }, false);
        let isFirefox = (/Firefox/i.test(navigator.userAgent));
        var mousewheelevt = isFirefox ? "DOMMouseScroll" : "mousewheel";
        this.viewer.canvas.addEventListener(mousewheelevt, (event) => {
            store.commit('hideThumbnailPopup',_this.viewType);
        }, false);

    }
    load() {
        var _this = this;
        this.viewer.addEventListener(Autodesk.Viewing.CAMERA_CHANGE_EVENT, () => {
            let position = this.viewer.navigation.getPosition();
            if (_this.isViewer2d() && !!store.state.selectedLevel?.mappingViewersPointsInfo?.isReady()) {
                position = store.state.selectedLevel.mappingViewersPointsInfo._2dTo3d(position);
            }

            this.pointClouds.forEach(o => this.updatePointCloudCameraPosition(o, position));

            if (_this.isViewer2d()) {
                let visibilityRange = this.getVisibilityRange();
                var bubblesAndImages = store.state.forgeService.getBubblesAndImages(this.viewer, position, visibilityRange);
                var count = bubblesAndImages.bubbles.length + bubblesAndImages.images.length;
                //update the images point cloud only if zooming changed
                if (this.imagesPointsCount !== count && Math.abs(_this.viewer.navigation.getPosition().z - _this.cameraZ) > 0.0000001) {
                    this.update360Images();
                    this.cameraZ = _this.viewer.navigation.getPosition().z;
                    this.imagesPointsCount = count;
                }
            }
        });

        this.viewer.addEventListener(Autodesk.Viewing.GEOMETRY_LOADED_EVENT, (event) => {
            _this.update360Images();
            _this.updateTags();
        });
        return true;
    }
    unload() {
        return true;
    }
    updatePointCloudCameraPosition(pointCloud, position) {
        if (!pointCloud) return;

        pointCloud.material.uniforms['cameraX'].value = position.x;
        pointCloud.material.uniforms['cameraY'].value = position.y;
        pointCloud.material.uniforms['cameraZ'].value = position.z;

        pointCloud.material.needsUpdate = true;
    }
    updateVisibilityRange() {
        let visRange = this.getVisibilityRange()
        let overlayVisRange = 16 / this.viewer.model.getUnitScale();
        this.pointClouds.forEach(o => {
            var range = o.type == 'tagsOverlay' ? Math.min(visRange, overlayVisRange) : visRange;
            o.material.uniforms['visibilityRange'].value = range;
            o.material.needsUpdate = true;
        });

        if (this.isViewer2d()) this.update360Images();
        
        this.viewer.impl.invalidate(false,false,true)
    }
    clear360ImagesIcons() {
        this.clearPointCloudsWithType('360Cluster')
        this.clearPointCloudsWithType('faro')
        this.clearPointCloudsWithType('leica')
        this.clearPointCloudsWithType('gps')
        this.clearPointCloudsWithType('geoslam')
        removeFromScene(this.clustersTextMeshes, this.viewer, this.sceneName);
        this.clustersTextMeshes = [];
    }
    update360Images() {
        if(!this.viewer || !this.viewer.impl)
            return;
        this.clear360ImagesIcons();
        if(this.isViewer2d() && (!store.state.selectedLevel || !store.state.selectedLevel.hasAllMappingInfo())) {
            this.viewer.impl.invalidate(true, true, true);
            return;
        }

        this.update360ImagesByType('360Cluster', this.textures['cluster'], this.textures['clusterHover'])
        if(this.isViewer2d())
            this.update360ImagesByType('faro', this.textures['faro2d'], this.textures['faro2dHover'])
        else
            this.update360ImagesByType('faro', this.textures['faro'], this.textures['faroHover'])

        if(this.isViewer2d())
            this.update360ImagesByType('leica', this.textures['leica2d'], this.textures['leica2dHover'])
        else
            this.update360ImagesByType('leica', this.textures['leica'], this.textures['leicaHover'])

        if(this.isViewer2d())
            this.update360ImagesByType('gps', this.textures['gps2d'], this.textures['gps2dHover'])
        else
            this.update360ImagesByType('gps', this.textures['gps'], this.textures['gpsHover'])

        if(this.isViewer2d())
            this.update360ImagesByType('geoslam', this.textures['geoslam2d'], this.textures['geoslam2dHover'])
        else
            this.update360ImagesByType('geoslam', this.textures['geoslam'], this.textures['geoslamHover'])


        if (this.isViewer2d()) this.updateClusterPoly();

        setTimeout(() => {
            if(this.viewer && this.viewer.impl)
                this.viewer.impl.invalidate(true, true, true);
        }, 100);
    }
    update360ImagesByType(type, texture, hoveringTexture) {
        let _this = this;
        var data = [];
        if (this.isViewer2d()) {
            let position = store.state.selectedLevel.mappingViewersPointsInfo._2dTo3d(this.viewer.navigation.getPosition());
            let visibilityRange = this.getVisibilityRange();
            var bubblesAndImages = store.state.forgeService.getBubblesAndImages(this.viewer, position, visibilityRange);
            //update shown 360 images
            if (store.state.userSettings.displaySettings.show360) {
                if(type == '360Cluster'){
                    if (bubblesAndImages.bubbles) {
                        bubblesAndImages.bubbles.forEach(list => {
                            var box = new THREE.Box3().setFromPoints(list.map(o => o.forgeCameraPosition));
                            var center = box.getCenter();
                            var pt = store.state.selectedLevel.mappingViewersPointsInfo._3dTo2d(center);
                            let points = list.map(o => store.state.selectedLevel.mappingViewersPointsInfo._3dTo2d(o.forgeCameraPosition));
                            pt.z = .1;
                            data.push({
                                name: list.length,
                                points: points,
                                point: pt,
                                onClick: () => {
                                    var min = store.state.selectedLevel.mappingViewersPointsInfo._3dTo2d(box.min);
                                    var max = store.state.selectedLevel.mappingViewersPointsInfo._3dTo2d(box.max);
                                    var bubbleBox = new THREE.Box3(min, max);
                                    _this.viewer.navigation.fitBounds(false, bubbleBox);
                                }
                            });
    
                            //draw clusters numbers texts
                            //let size = .02 * this.viewer.navigation.getPosition().z;
                            let size = 12 / (this.viewer.worldToClient(new THREE.Vector2(1,0)).x-this.viewer.worldToClient(new THREE.Vector2(0,0)).x);
                            let textPt = new THREE.Vector3(pt.x, pt.y, pt.z + .05);
                            let textMesh = createTextGl(list.length, size, 0xffffff, textPt, this.viewer, this.sceneName);
                            this.clustersTextMeshes.push(textMesh);
    
                        });
                    }
                }else{
                    if (bubblesAndImages.images) {
                        bubblesAndImages.images.filter(o=>o.scanType == type).forEach(img => {
                            var pt = store.state.selectedLevel.mappingViewersPointsInfo._3dTo2d(img.forgeCameraPosition);
                            pt.z = .1;
                            data.push({
                                name: img.name,
                                thumbnailURL: img.thumbnailURL,
                                type: img.scanType,
                                point: pt,
                                object:img,
                                onClick: (event) => {
                                    store.state.forgeService.onClickOn3dIcon(img,event,_this.viewType);
                                }
                            })
                        });
                    }
                }
            }
        } else {
            const GLOBAL_SEARCH_TAB_INDEX = 0;
            let isGlobalSearchTabShown = store.state.isTabShown && store.state.selectedTab == GLOBAL_SEARCH_TAB_INDEX;
            var images = store.state.forgeService.getAllShownPanoramaImagesIn3D().filter(o=>o.scanType == type);
            images = images.filter(o => store.state.forgeService.getMainExtension()?.isWithinCropBox(o.getCameraPositionInViewer()));
            if (isGlobalSearchTabShown && store.getters['GET_GLOBAL_SEARCH_TEXT'])
                images = images.filter(o => store.state.filtered360Imgs.includes(o));

            images.forEach(img => {
                let point = img.getCameraPositionInViewer();
                data.push({
                    name: img.name,
                    thumbnailURL: img.thumbnailURL,
                    object:img,
                    type: img.scanType,
                    point: point,
                    onClick: (event) => {
                        store.state.forgeService.onClickOn3dIcon(img,event,_this.viewType);
                    }
                })
            });
        }
        //this approach based on that all images are one type per project, if changed will need to change the approach.
        if (data.length > 0) {
            let visRange = parseFloat(store.state.userSettings.displaySettings.getVisibilityRangeInViewer());
            let images360Geometry = this.getPointCloudGeometryForData(data);
            let images360PointCloud = this.initMesh_PointCloud(images360Geometry,texture , hoveringTexture, true, false,visRange)
            images360PointCloud.forgeData = data;
            images360PointCloud.type = type;
            this.pointClouds.push(images360PointCloud);
        }
    }
    clear3DTags(){
        this.clearPointCloudsWithType('equipment_2d')
        this.clearPointCloudsWithType('auto_equipment')
        this.clearPointCloudsWithType('equipment')
        this.clearPointCloudsWithType('structural')
        this.clearPointCloudsWithType('manual_structural')
        this.clearPointCloudsWithType('manual_pipelines')
        this.clearPointCloudsWithType('annotation')
        this.clearPointCloudsWithType('inspection')
        this.clearPointCloudsWithType('amisTag')
        this.clearPointCloudsWithType('scaffold')
        this.clearPointCloudsWithType('permit')
        this.clearPointCloudsWithType('container')

        this.clearPointCloudsWithType('equipment_2dOverlay')
        this.clearPointCloudsWithType('auto_equipmentOverlay')
        this.clearPointCloudsWithType('equipmentOverlay')
        this.clearPointCloudsWithType('structuralOverlay')
        this.clearPointCloudsWithType('manual_structuralOverlay')
        this.clearPointCloudsWithType('pipelineOverlay')
        this.clearPointCloudsWithType('manual_pipelinesOverlay')
        this.clearPointCloudsWithType('annotationOverlay')
        this.clearPointCloudsWithType('inspectionOverlay')
        this.clearPointCloudsWithType('amisTagOverlay')
        this.clearPointCloudsWithType('scaffoldOverlay')
        this.clearPointCloudsWithType('permitOverlay')
        this.clearPointCloudsWithType('containerOverlay')

        this.clearHighlightingTags();

        this.areas2d.forEach(o => disposeArea2d(o, this.viewer, this.sceneName))
        this.areas2d = [];
    }
    clearPointCloudsWithType(type){
        for (let i = this.pointClouds.length - 1; i >= 0; i--) {
            if (this.pointClouds[i].type != type)
                continue;
            removeFromScene(this.pointClouds[i], this.viewer, this.sceneName);
            this.pointClouds.splice(i, 1);
        }
    }
    updateTags() {
        if(!this.viewer || !this.viewer.impl) return;
        
        this.areas2d.forEach(o => disposeArea2d(o, this.viewer, this.sceneName))
        this.areas2d = [];
        this.clear3DTags();

        let hoveringColor = new THREE.Color(this.hoveringColor)
        let hoverColorVector = new THREE.Vector3(hoveringColor.r,hoveringColor.g,hoveringColor.b)
        
        this.updateTagsWithType('equipment_2d',this.textures["location2d"],ForgeEquipment.getLabelColorVector(),hoverColorVector);
        
        this.updateTagsWithType('manual_pipelines',this.textures["pin"],ForgePipeline.getLabelColorVector(),hoverColorVector)
        this.updateTagsWithType('pipeline',this.textures["pin"],ForgePipeline.getLabelColorVector(),hoverColorVector)
        this.updateTagsWithType('manual_structural',this.textures["pin"],ForgeStructural.getLabelColorVector(),hoverColorVector)
        this.updateTagsWithType('structural',this.textures["pin"],ForgeStructural.getLabelColorVector(),hoverColorVector)
        this.updateTagsWithType('equipment',this.textures["pin"],ForgeEquipment.getLabelColorVector(),hoverColorVector)
        this.updateTagsWithType('auto_equipment',this.textures["pin"],ForgeEquipment.getLabelColorVector(),hoverColorVector);
        this.updateTagsWithType('annotation',this.textures["pin"],ForgeAnnotation.getLabelColorVector(this.viewType),hoverColorVector)
        this.updateTagsWithType('inspection',this.textures["pin"],ForgeInspection.getLabelColorVector(),hoverColorVector)
        this.updateTagsWithType('amisTag',this.textures["pin"],ForgeInspection.getLabelColorVector(),hoverColorVector)
        this.updateTagsWithType('scaffold',this.textures["pin"],ForgeScaffold.getLabelColorVector('scaffold', this.viewType),hoverColorVector)
        this.updateTagsWithType('permit',this.textures["pin"],ForgeScaffold.getLabelColorVector('permit', this.viewType),hoverColorVector)
        this.updateTagsWithType('container',this.textures["pin"],ForgeScaffold.getLabelColorVector('container', this.viewType),hoverColorVector)

        setTimeout(() => {
            if(this.viewer && this.viewer.impl)
                this.viewer.impl.invalidate(true, true, true);
        }, 100);
    }
    updateTagsWithType(type, texture, textureColor, hoveringTextureColor) {
        let isGlobalSearchTabShown = store.state.isTabShown && store.state.selectedTab == 0;
        let isGlobalSearchFilter = isGlobalSearchTabShown && store.getters['GET_GLOBAL_SEARCH_TEXT'];
        let { showTags, showAutoEquipment, showPipelines, showManualPipelines, showStructural, showManualStructural, showAnnotations, showInspections, showScaffolds, showPermits, showDeckManagment } = store.state.userSettings.displaySettings
        var data = {};
        let _this = this;
        //equipments
        if (showTags && type == 'equipment') {
            var allEquipments = store.state.forgeService.getEquipmentsInLevel(store.state.selectedLevel);

            var equipments = type == 'equipment' ? allEquipments.filter(e => !e.level2D) : allEquipments.filter(e => !!e.level2D);

            equipments = this.isViewer2d() ? equipments : store.state.tags;

            for (let i = 0; i < equipments.length; i++) {
                const equipment = equipments[i];

                if (isGlobalSearchFilter && !store.state.filteredTags.includes(equipment)) continue;

                let point = this.isViewer2d() ? store.state.selectedLevel.mappingViewersPointsInfo._3dTo2d(equipment.point) : equipment.getPointInView();

                // point.z = .1;
                // [FORGE-684] shift all rendered 2d equipments by fixed value because of an issue of exact overlapping when some inspections/equipments are created by exactly same objects
                if (!this.isViewer2d() && !store.state.forgeService.getMainExtension()?.isWithinCropBox(point)) continue;

                if (this.isViewer2d()) point.z = .1;

                let pcData = {
                    name: equipment.name,
                    thumbnailURL: equipment.thumbnailUrl,
                    object: equipment,
                    point: point,
                    onClick: (event) => {
                        store.state.forgeService.onClickOn3dIcon(equipment, event, _this.viewType);
                    }
                }
                
                let category = equipment.category;

                data[category] ? data[category].push(pcData) : data[category] = [pcData];
            }
        }
        else if (showTags && this.isViewer2d() && type == 'equipment_2d') {
            let equipments = store.state.forgeService.getEquipmentsInLevel(store.state.selectedLevel).filter(e => !!e.level2D);
        
            for (let i = 0; i < equipments.length; i++) {
                const equipment = equipments[i];

                if (isGlobalSearchFilter && !store.state.filteredTags.includes(equipment)) continue;

                let point = store.state.selectedLevel.mappingViewersPointsInfo._3dTo2d(equipment.point);

                point.z = .1;

                let pcData = {
                    name: equipment.name,
                    thumbnailURL: equipment.thumbnailUrl,
                    object: equipment,
                    point: point,
                    onClick: (event) => {
                        store.state.forgeService.onClickOn3dIcon(equipment, event, _this.viewType);
                    }
                }
                
                let category = equipment.category;

                data[category] ? data[category].push(pcData) : data[category] = [pcData];
            }
        }
        // Auto Equipment
        else if (showAutoEquipment && this.isViewer2d() && type == 'auto_equipment') {
            let equipments = store.state.forgeService.getAutoEquipmentsInLevel(store.state.selectedLevel);
            var filteredAutoTags = store.getters['GET_AUTOMATIC_TAGS'];
            
            for (let i = 0; i < equipments.length; i++) {
                const equipment = equipments[i];

                if (isGlobalSearchFilter && !filteredAutoTags.some(t => t.id == equipment.id)) continue;

                equipment.point = Object.assign(new THREE.Vector3(), equipment.point)

                let point = store.state.selectedLevel.mappingViewersPointsInfo._3dTo2d(equipment.point);

                // point.z = .1;
                // [FORGE-684] shift all rendered 2d equipments by fixed value because of an issue of exact overlapping when some inspections/equipments are created by exactly same objects
                point.x += .001;

                let pcData = {
                    name: equipment.name,
                    thumbnailURL: equipment.thumbnailUrl,
                    object: equipment,
                    point: point,
                    onClick: (event) => {
                        store.dispatch('getAutomaticTagTagById', equipment.id).then(tag => {
                            store.state.forgeService.onClickOn3dIcon(tag, event, _this.viewType);
                        })
                    }
                }
                
                let category = equipment.category ?? 1;

                data[category] ? data[category].push(pcData) : data[category] = [pcData];
            }
        }
        //pipelines
        else if (showManualPipelines && type == 'manual_pipelines') {
            let tags = store.state.forgeService.getManualPipelineTagsInLevel(store.state.selectedLevel);

            let pipelines = this.isViewer2d() ? tags : store.getters.GET_MANUAL_PIPELINES_TAGS;

            for (let i = 0; i < pipelines.length; i++) {
                const pipeline = pipelines[i];

                if (isGlobalSearchFilter && !store.state.filteredTags.includes(pipeline)) continue;

                let point = this.isViewer2d() ? store.state.selectedLevel.mappingViewersPointsInfo._3dTo2d(pipeline.point) : pipeline.getPointInView();

                if (!this.isViewer2d() && !store.state.forgeService.getMainExtension()?.isWithinCropBox(point)) continue;

                if (this.isViewer2d()) point.z = .1;

                let pcData = {
                    name: pipeline.name,
                    thumbnailURL: pipeline.thumbnailUrl,
                    object: pipeline,
                    point: point,
                    onClick: (event) => {
                        store.state.forgeService.onClickOn3dIcon(pipeline, event, _this.viewType);
                    }
                }
                
                let category = pipeline.category;

                data[category] ? data[category].push(pcData) : data[category] = [pcData];
            }
        }
        else if (showPipelines && this.isViewer2d() && type == 'pipeline') {
            let tags = store.state.forgeService.getPipelineTagsInLevel(store.state.selectedLevel);
            let filteredTagsIds = store.getters.GET_FILTERED_PIPELINES;

            for (let i = 0; i < tags.length; i++) {
                const tag = tags[i];

                if (isGlobalSearchFilter && !filteredTagsIds.some(id => id == tag.id)) continue;

                tag.point = Object.assign(new THREE.Vector3(), tag.point)

                let point = store.state.selectedLevel.mappingViewersPointsInfo._3dTo2d(tag.point);

                point.x += .001;

                let pcData = {
                    name: tag.name,
                    thumbnailURL: tag.thumbnailUrl,
                    object: tag,
                    point: point,
                    onClick: (event) => {
                        store.dispatch('FETCH_PIPELINE_TAG_BY_ID', tag.id).then(tag => {
                            store.state.forgeService.onClickOn3dIcon(tag, event, _this.viewType);
                        })
                    }
                }
                
                let category = tag.category ?? 1;

                data[category] ? data[category].push(pcData) : data[category] = [pcData];
            }
        }
        //structural
        else if (showManualStructural &&  type == 'manual_structural') {
            let tags = store.state.forgeService.getManualStructuralTagsInLevel(store.state.selectedLevel);

            var structuralTags = this.isViewer2d() ? tags : store.getters.GET_MANUAL_STRUCTURAL_TAGS;

            for (let i = 0; i < structuralTags.length; i++) {

                const structural = structuralTags[i];

                if (isGlobalSearchFilter && !store.state.filteredTags.includes(structural)) continue;

                let point = this.isViewer2d() ? store.state.selectedLevel.mappingViewersPointsInfo._3dTo2d(structural.point) : structural.getPointInView();

                if (!this.isViewer2d() && !store.state.forgeService.getMainExtension()?.isWithinCropBox(point)) continue;

                if (this.isViewer2d()) point.z = .1;

                let pcData = {
                    name: structural.name,
                    thumbnailURL: structural.thumbnailUrl,
                    object: structural,
                    point: point,
                    onClick: (event) => {
                        store.state.forgeService.onClickOn3dIcon(structural, event, _this.viewType);
                    }
                }

                let category = structural.category;

                data[category] ? data[category].push(pcData) : data[category] = [pcData];
            }
        }
        else if (showStructural && this.isViewer2d() &&  type == 'structural') {
            let tags = store.state.forgeService.getStructuralTagsInLevel(store.state.selectedLevel);
            var filteredTagsIds = store.getters.GET_STRUCTURAL_TAGS.map(t => t.id);

            for (let i = 0; i < tags.length; i++) {
                const tag = tags[i];

                if (isGlobalSearchFilter && !filteredTagsIds.some(id => id == tag.id)) continue;

                tag.point = Object.assign(new THREE.Vector3(), tag.point)

                let point = store.state.selectedLevel.mappingViewersPointsInfo._3dTo2d(tag.point);

                point.x += .001;

                let pcData = {
                    name: tag.name,
                    thumbnailURL: tag.thumbnailUrl,
                    object: tag,
                    point: point,
                    onClick: (event) => {
                        store.dispatch('FETCH_STRUCTURAL_TAG_BY_ID', tag.id).then(tag => {
                            store.state.forgeService.onClickOn3dIcon(tag, event, _this.viewType);
                        });
                    }
                }
                
                let category = tag.category ?? 1;

                data[category] ? data[category].push(pcData) : data[category] = [pcData];
            }
        }
        //annotations
        else if (showAnnotations && 'annotation' == type) {
            var annotations = this.isViewer2d() ? store.state.forgeService.getAnnotationsInLevel(store.state.selectedLevel) : store.state.annotations;
            
            if (this.isViewer2d()) {
                annotations = store.state.forgeService.updateListWithEditingTag(annotations);
            }

            for (let i = 0; i < annotations.length; i++) {
                const annotation = annotations[i];

                if (annotation.level2D && (!this.isViewer2d() || annotation.level2D != store.state.selectedLevel.name)) continue;

                if (isGlobalSearchTabShown && store.getters['GET_GLOBAL_SEARCH_TEXT'] && !store.state.filteredAnnotations.includes(annotation)) continue;

                let point = this.isViewer2d() ? store.state.selectedLevel.mappingViewersPointsInfo._3dTo2d(annotation.point) : annotation.getPointInView();

                if (!this.isViewer2d() && !store.state.forgeService.getMainExtension()?.isWithinCropBox(point)) continue;

                // if(this.isViewer2d()) point.z = .1;

                let pcData = {
                    name: annotation.name,
                    thumbnailURL: annotation.thumbnailUrl,
                    object: annotation,
                    point: point,
                    onClick: (event) => {
                        store.state.forgeService.onClickOn3dIcon(annotation, event, _this.viewType);
                    }
                }
                
                let category = annotation.category;

                data[category] ? data[category].push(pcData) : data[category] = [pcData];
                
                this.drawTagArea(annotation)
            }
        }
        //inspections
        else if (showInspections && type =='inspection' && !store.state.forgeSettings.isAMIS) {
            var filteredInspections = [];
            
            if (isGlobalSearchTabShown && store.getters['GET_GLOBAL_SEARCH_TEXT']) {
                let InspectionSelectedFilter = store.state.TAGS.InspectionSelectedFilter ?? 'Remaining Thickness';
                let selectedColorsOptions = store.state.TAGS.InspectionAvailableColorOptions;

                store.state.forgeService.advancedUpdateAMISTagsColors(store.state.filteredInspections, InspectionSelectedFilter, selectedColorsOptions, '#0f7968');
                filteredInspections = store.state.filteredInspections.filter(t => !!t.point);
            } else if (!!store.state.TAGS.InspectionSelectedFilter && !!store.state.TAGS.selectedColorOptions.length) {
                filteredInspections = store.getters['GET_FILTERED_INSPECTIONS'].filter(t => !!t.point);
            }

            var inspections = this.isViewer2d() ? store.state.forgeService.getInspectionsInLevel(store.state.selectedLevel, filteredInspections) : filteredInspections;
            
            if (this.isViewer2d()) {
                inspections = store.state.forgeService.updateListWithEditingTag(inspections);
            }

            if (isGlobalSearchTabShown && store.getters['GET_GLOBAL_SEARCH_TEXT']) {
                let InspectionSelectedFilter = store.state.TAGS.InspectionSelectedFilter ?? 'Remaining Thickness';
                let selectedColorsOptions = store.state.TAGS.InspectionAvailableColorOptions;

                store.state.forgeService.advancedUpdateAMISTagsColors(filteredInspections, InspectionSelectedFilter, selectedColorsOptions, '#0f7968');
            }

            for (let i = 0; i < inspections.length; i++) {
                const inspection = inspections[i];

                if (inspection.level2D && (!this.isViewer2d() || inspection.level2D != store.state.selectedLevel.name)) continue;

                if (isGlobalSearchTabShown && store.getters['GET_GLOBAL_SEARCH_TEXT'] && !store.state.filteredInspections.includes(inspection)) continue;

                let point = this.isViewer2d() ? store.state.selectedLevel.mappingViewersPointsInfo._3dTo2d(inspection.point) : inspection.getPointInView();

                if (!this.isViewer2d() && !store.state.forgeService.getMainExtension()?.isWithinCropBox(point)) continue;

                // if(this.isViewer2d()) point.z = .1;

                let pcData = {
                    name: inspection.name,
                    thumbnailURL: inspection.thumbnailUrl,
                    object: inspection,
                    pinColor: inspection.getPinVector(),
                    point: point,
                    onClick: (event) => {
                        store.state.forgeService.onClickOn3dIcon(inspection, event, _this.viewType);
                    }
                }
                
                let category = inspection.category;

                if (data[category]){
                    data[category].push(pcData)
                }
                else {
                    data[category] = [pcData]
                }
                
                this.drawTagArea(inspection)
            }
        }
        //amis tags
        else if (showInspections && type =='amisTag' && store.state.forgeSettings.isAMIS) {

            let amisTags = []

            if (isGlobalSearchTabShown && store.getters['GET_GLOBAL_SEARCH_TEXT']) {
                let InspectionSelectedFilter = store.state.TAGS.InspectionSelectedFilter ?? 'Remaining Thickness';
                let selectedColorsOptions = store.state.TAGS.InspectionAvailableColorOptions;

                store.state.forgeService.advancedUpdateAMISTagsColors(store.state.filteredInspections, InspectionSelectedFilter, selectedColorsOptions, '#0f7968');
                amisTags = store.state.filteredInspections.filter(t => !!t.point);
            } else if (store.state.TAGS.InspectionSelectedFilter) {
                if (store.state.TAGS.InspectionSelectedFilter != 'Inspection Tag') {
                    amisTags = store.getters['GET_ALL_AMIS_FILTERED_INSPECTIONS'].filter(t => !!t.point);
                }
            }

            let inspections = this.isViewer2d() ? store.state.forgeService.getInspectionsInLevel(store.state.selectedLevel, amisTags) : amisTags;

            for (let i = 0; i < inspections.length; i++) {
                const tag = inspections[i];
                let point = this.isViewer2d() ? store.state.selectedLevel.mappingViewersPointsInfo._3dTo2d(tag.point) : store.state.forgeService.worldToView3d(tag.point, tag.point);
                
                if (!this.isViewer2d() && !store.state.forgeService.getMainExtension()?.isWithinCropBox(point)) continue;

                // if(this.isViewer2d()) point.z = .1;

                let pcData = {
                    name: tag.name,
                    thumbnailURL: tag.thumbnailUrl,
                    object:tag,
                    point: point,
                    onClick: (event) => {
                        getAMISTagById(tag.id).then(tag => {
                            store.state.forgeService.onClickOn3dIcon(tag, event, _this.viewType);
                        })
                    }
                }

                data[tag.pinColor] ? data[tag.pinColor].push(pcData) : data[tag.pinColor] = [pcData];
            }
        }           
        //scaffolds
        else if (showScaffolds || showPermits || showDeckManagment) {
            var scaffolds = this.isViewer2d() ? store.state.forgeService.getScaffoldsInLevel(store.state.selectedLevel) : store.state.scaffolds;

            scaffolds = store.state.forgeService.updateListWithEditingTag(scaffolds);

            for (var i = 0; i < scaffolds.length; i++) {
                let scaffold = scaffolds[i];

                if(scaffold.type != type) continue;

                let point = this.isViewer2d() ? store.state.selectedLevel.mappingViewersPointsInfo._3dTo2d(scaffold.position) : scaffold.getPointInView();

                point.z = /* this.isViewer2d() ? 0.1 : */ (point.z + .5 * scaffold.height + 0.2);

                if (scaffold.isScaffold()) {
                    if (!showScaffolds) continue;
                    if (isGlobalSearchTabShown && store.getters['GET_GLOBAL_SEARCH_TEXT'] && !store.state.filteredScaffolds.includes(scaffold)) continue;
                } else if (scaffold.isPermit()) {
                    if (!showPermits) continue;
                    if (isGlobalSearchTabShown && store.getters['GET_GLOBAL_SEARCH_TEXT'] && !store.state.filteredPermits.includes(scaffold)) continue;
                } else if (scaffold.isContainer()) {
                    if (!showDeckManagment) continue;
                    if (isGlobalSearchTabShown && store.getters['GET_GLOBAL_SEARCH_TEXT'] && !store.state.filteredContainers.includes(scaffold)) continue;
                }

                let color = scaffold.getPinVector();

                let pcData = {
                    name: scaffold.name,
                    thumbnailURL: scaffold.thumbnailUrl,
                    object: scaffold,
                    pinColor: color,
                    point: point,
                    onClick: (event) => {
                        store.state.forgeService.onClickOn3dIcon(scaffold, event, _this.viewType);
                    }
                }

                data[0] ? data[0].push(pcData) : data[0] = [pcData];

                this.drawTagArea(scaffold)
            }
        }

        let vr = parseFloat(store.state.userSettings.displaySettings.getVisibilityRangeInViewer());

        for (const [key, value] of Object.entries(data)) {
            if (value.length == 0) continue;

            let color = new THREE.Color(3.0, 3.0, 3.0);

            if (type == 'amisTag') {
                color = new THREE.Color(key);
            } else {
                let c = store.state.forgeService.getCategoryColor(key);
                color = new THREE.Color(c.r, c.g, c.b);
            }

            value.forEach(tag => {
                if (!tag.point) return;

                let geometry = this.getPointCloudTagGeometry(tag, color);

                let textColor = tag.pinColor ? tag.pinColor : textureColor;

                let pc = this.initMesh_PointCloud_Tag(geometry, texture, textColor, hoveringTextureColor, true, (type == 'amisTag'), vr);
                pc.forgeData = [tag];
                pc.type = type;
                pc.isTag = true;
                this.pointClouds.push(pc);

                if (!this.isViewer2d()) {
                    let overlayPc = this.initMesh_PointCloud_Tag(geometry, texture, textColor, hoveringTextureColor, false, (type == 'amisTag'), 16 / this.viewer.model.getUnitScale())
                    overlayPc.forgeData = [tag];
                    overlayPc.type = type + 'Overlay';
                    overlayPc.isTag = true;
                    this.pointClouds.push(overlayPc);
                }
            });

            // ** Old way to create pointClouds contains smaller tags.
            // let tagsGeometry = this.getPointCloudGeometryForTags(value, color);
            // let tagsPointCloud = this.initMesh_PointCloud_Tag(tagsGeometry, texture, textureColor, hoveringTextureColor, true, (type == 'amisTag'), vr)
            // tagsPointCloud.forgeData = value;
            // tagsPointCloud.type = type;
            // tagsPointCloud.isTag = true;
            // this.pointClouds.push(tagsPointCloud);

            // let tagsOverlayPointCloud = this.initMesh_PointCloud_Tag(tagsGeometry, texture, textureColor, hoveringTextureColor, false, (type == 'amisTag'), 16 / this.viewer.model.getUnitScale())
            // tagsOverlayPointCloud.forgeData = value;
            // tagsOverlayPointCloud.type = type + 'Overlay';
            // tagsOverlayPointCloud.isTag = true;
            // this.pointClouds.push(tagsOverlayPointCloud);
        }

    }
    drawTagArea(tag){
        //draw tag area
        if(tag.area2dCoordinates && this.isViewer2d()){
            let area = this.drawTagAreaByColor(tag,null)
            this.areas2d.push(area)
        }
    }
    drawTagAreaByColor(tag,color){
        let points = tag.area2dPoints.map(o=>store.state.selectedLevel.mappingViewersPointsInfo._3dTo2d(o))
        if(!color){
            color = tag.getLabelColor()
            if(tag.getCategoryColor){
                let categColor = tag.getCategoryColor();
                if(categColor)
                    color = new THREE.Color(color.r, color.g, color.b).getHex()
            }
        }
        let area = drawArea2d(points,this.viewer,this.sceneName,color);
        area.tempPolyGl.material.depthTest = true;
        area.tempPolyGl.material.depthWrite = true;
        area.tempPolyGl.position.setZ(.5);
        return area
    }
    getPointCloudGeometryForData(data) {
        var position = new Float32Array(data.length * 3);
        var color = new Float32Array(data.length * 3);
        var position3d = new Float32Array(data.length * 3);

        for (let i = 0; i < data.length; i++) {
            const p = data[i];

            // Position
            position[(i*3)]     = p.point.x;
            position[(i*3) + 1] = p.point.y;
            position[(i*3) + 2] = p.point.z;
        
            // Color
            // icon = 0..2 position in the horizontal icons.png sprite sheet
            color[(i*3)]     = 0;
            color[(i*3) + 1] = 0;
            color[(i*3) + 2] = 0;

            if (this.isViewer2d()) {
                let point = store.state.selectedLevel.mappingViewersPointsInfo._2dTo3d(p.point);
                position3d[(i*3)]     = point.x;
                position3d[(i*3) + 1] = point.y;
                position3d[(i*3) + 2] = point.z;
            }
        }

        var geometry = new THREE.BufferGeometry();

        geometry.setAttribute('position', new THREE.BufferAttribute(position, 3));
        geometry.setAttribute('color', new THREE.BufferAttribute(color, 3));
        geometry.setAttribute('position3d', new THREE.BufferAttribute(position3d, 3));

        return geometry;
    }

    // getPointCloudGeometryForTags(data, color) {
    //     var geometry = new Geometry();

    //     data.map(item => {
    //         geometry.vertices.push(item.point.clone());

    //         let c = new THREE.Color(color.r, color.g, color.b);

    //         // Trying to adjust three.js color to match the correct color.
    //         if (c.r <= 1 && c.g <= 1 && c.b <= 1 ) {
    //             c.r = c.r * 0.75;
    //             c.g = c.g * 0.75;
    //             c.b = c.b * 0.75;
    //         }

    //         geometry.colors.push(c); // icon = 0..2 position in the horizontal icons.png sprite sheet
    //     });

    //     geometry.addAttribute('actualPosition', new Float32BufferAttribute(myArray, 1));
        
    //     return geometry;
    // }

    getPointCloudTagGeometry(tag, _color) {
        var position = new Float32Array(3);
        var color = new Float32Array(3);
        var position3d = new Float32Array(3);

        position[0] = tag.point.x;
        position[1] = tag.point.y;
        position[2] = tag.point.z;

        let c = new THREE.Color(_color.r, _color.g, _color.b);

        // Trying to adjust three.js color to match the correct color.
        if (c.r <= 1 && c.g <= 1 && c.b <= 1 ) {
            c.r = c.r * this.colorCorrection;
            c.g = c.g * this.colorCorrection;
            c.b = c.b * this.colorCorrection;
        }

        color[0] = c.r;
        color[1] = c.g;
        color[2] = c.b;

        if (this.isViewer2d()) {
            let point = store.state.selectedLevel.mappingViewersPointsInfo._2dTo3d(tag.point);
            // let point = tag.point;
            position3d[0] = point.x;
            position3d[1] = point.y;
            position3d[2] = point.z;
        }

        var geometry = new THREE.BufferGeometry();

        geometry.setAttribute('position', new THREE.BufferAttribute(position, 3));
        geometry.setAttribute('color', new THREE.BufferAttribute(color, 3));
        geometry.setAttribute('position3d', new THREE.BufferAttribute(position3d, 3));

        return geometry;
    }

    initMesh_PointCloud(geometry, texture, hoveringTexture, depthWrite, isTag ,visibilityRange) {
        // create new point cloud material
        let position = this.viewer.navigation.getPosition();

        if (this.isViewer2d()) {
            position = store.state.selectedLevel.mappingViewersPointsInfo._2dTo3d(position);
        }

        var material = new THREE.ShaderMaterial({
            vertexColors: true,
            vertexShader: this.vertexShader,
            fragmentShader: this.fragmentShader,
            depthWrite: depthWrite,
            depthTest: depthWrite,
            uniforms: {
                isTag: { type: "i", value: isTag ? 1 : 0 },
                isViewer2d: { type: "i", value: this.isViewer2d() ? 1 : 0 },
                tex: { type: "t", value: texture },
                hoveringTexture: { type: "t", value: hoveringTexture },
                visibilityRange: { type: "f", value: visibilityRange },
                cameraX: { type: "f", value: position.x },
                cameraY: { type: "f", value: position.y },
                cameraZ: { type: "f", value: position.z },
                scaleFactor: { type: "f", value: this.isViewer2d() ? 1.0 : 1/this.viewer.model.getUnitScale() },
            }
        });

        var pointCloud = new THREE.PointCloud(geometry, material);
        addToScene(pointCloud, this.viewer, this.sceneName);
        return pointCloud;
    }

    initMesh_PointCloud_Tag(geometry, texture, textureColor, hoveringTextureColor, depthWrite, isMISTag ,visibilityRange) {
        // create new point cloud material
        let position = this.viewer.navigation.getPosition();

        if (this.isViewer2d()) {
            position = store.state.selectedLevel.mappingViewersPointsInfo._2dTo3d(position);
        }

        var material = new THREE.ShaderMaterial({
            vertexColors: true,
            vertexShader: this.vertexShader,
            fragmentShader: this.tagsFragmentShader,
            depthWrite: depthWrite,
            depthTest: depthWrite,
            uniforms: {
                isTag: { type: "i", value: 1 },
                isViewer2d: { type: "i", value: this.isViewer2d() ? 1 : 0 },
                isMISTag:{ type: "i", value: isMISTag ? 1 : 0 },
                tex: { type: "t", value: texture },
                textureColor: { type: "v3", value: textureColor },
                hoveringTextureColor: { type: "v3", value: hoveringTextureColor },
                visibilityRange: { type: "f", value: visibilityRange },
                cameraX: { type: "f", value: position.x },
                cameraY: { type: "f", value: position.y },
                cameraZ: { type: "f", value: position.z },
                scaleFactor: { type: "f", value: this.isViewer2d() ? 1.0 : 1/this.viewer.model.getUnitScale() },
            }
        });

        var pointCloud = new THREE.PointCloud(geometry, material);

        //to set the icons above the 2d areas
        if(this.isViewer2d()) pointCloud.position.setZ(1);

        addToScene(pointCloud, this.viewer, this.sceneName);
        
        return pointCloud;
    }
    onMouseMove(event) {
        if (!this.viewer || !this.viewer.model)
            return;
        if(this.isViewer2d()) disposeArea2d(this.hoveringArea,this.viewer,this.sceneName);

        if(this.isViewer2d() && store.state.forgeService.getDrawPointsExtension()?.measuringAreaOn) return;

        //clear all hovering
        this.pointClouds.forEach(o => {
            let colorAttribute = o.geometry.attributes.color;
            let length = colorAttribute.count;

            for (let i = 0; i < length; i++) {
                let x = i * colorAttribute.itemSize;

                if (o.isTag) {
                    let categoryColor = new THREE.Color(3.0, 3.0, 3.0);

                    if (o.forgeData[i].object instanceof ForgeInspection && o.forgeData[i].object.isFetched) {
                        let color = o.forgeData[i].object.pinColor;
                        categoryColor = new THREE.Color(color)
                    } else if (o.forgeData[i].object.category > 0) {
                        let color = o.forgeData[i].object.getCategoryColor();

                        if (color) {
                            categoryColor = new THREE.Color(color.r, color.g, color.b)
                        }
                    } 
                    
                    // Trying to adjust three.js color to match the correct color.
                    colorAttribute.array[x] = categoryColor.r * this.colorCorrection;
                    colorAttribute.array[x + 1] = categoryColor.g * this.colorCorrection;
                    colorAttribute.array[x + 2] = categoryColor.b * this.colorCorrection;
                } else {
                    if (colorAttribute.array[x] > 4 && colorAttribute.array[x + 1] > 4 && colorAttribute.array[x + 2] > 4) {
                        colorAttribute.array[x] = 0.0
                        colorAttribute.array[x + 1] = 0.0
                        colorAttribute.array[x + 2] = 0.0
                    }
                }
            }

            o.geometry.attributes.color.needsUpdate = true;
        });

        this.viewer.impl.invalidate(false,false,true);

        this.hoveringPointCloud = null;
        let raycaster = pointerToRaycaster(this.viewer, event);
        this.updateHitTestForPointCloud(raycaster, this.pointClouds, event)

        if(this.isViewer2d()) this.updateClusterPoly();
    }
    updateClusterPoly() {
        //update cluster hovering area
        let needsUpdate = false;
        if (this.clusterHoveringAreaMesh) {
            removeFromScene(this.clusterHoveringAreaMesh, this.viewer, this.sceneName)
            this.clusterHoveringAreaMesh = null;
            needsUpdate = true;
        }

        if (this.clusterPolyBorderGl?.length) {
            removeFromScene(this.clusterPolyBorderGl, this.viewer, this.sceneName)
            this.clusterPolyBorderGl = [];
            needsUpdate = true;
        }

        if (this.hoveringPointCloud && this.hoveringPointCloud.type == '360Cluster') {
            let poly = convexHull(this.hoveringPointCloud.forgeData[this.hovered].points)
            if (poly) {
                this.clusterPolyBorderGl = [];
                for (let i = 0; i < poly.length - 1; i++) {
                    let lineGl = drawLine(poly[i], poly[i + 1], 0x0000ff, this.viewer, this.sceneName);
                    this.clusterPolyBorderGl.push(lineGl);
                }
                if (poly.length > 2)
                    this.clusterHoveringAreaMesh = drawPolygon(poly, 0x808080, this.viewer, this.sceneName);
                needsUpdate = true;
            }
        }

        if (needsUpdate) this.viewer.impl.invalidate(false, false, true);
    }
    isViewer2d() {
        return this.viewer == store.state.planViewer;
    }
    onClick(event) {
        if (this.hovered == -1) return;

        this.selected = this.hovered;
        //Do it after a while for the case if the user clicked on a 360 icon and there was a tagged 3d object under the mouse
        setTimeout(() => {
            this.hoveringPointCloud?.forgeData[this.selected].onClick(event);
            this.viewer.clearSelection();
        }, 50);
    }
    updateHitTestForPointCloud(raycaster, pointClouds, event) {
        // https://stackoverflow.com/questions/28209645/raycasting-involving-individual-points-in-a-three-js-pointcloud
        var nodes = raycaster.intersectObjects(pointClouds)
        .filter(o => o.distance > 0 && this.isWithinTolerance(o.point, o.object.forgeData[o.index].point, 30));
                
        if (nodes.length == 0) {
            var tolerance = this.isViewer2d() ? .004 : .1 / this.viewer.model.getUnitScale();
            for (let i = 0; i < pointClouds.length; i++) {
                for (let j = 0; j < pointClouds[i].forgeData.length; j++) {
                    let pt = pointClouds[i].forgeData[j].point;

                    let distance = raycaster.ray.distanceToPoint(pt);
                    //increase the tolerance for in case if the user zoomed out far of the model.
                    let tole = this.isViewer2d() ? tolerance : tolerance + this.viewer.navigation.getPosition().distanceTo(pt) * 0.006
                    if (tole > distance) {
                        nodes.push({
                            object: pointClouds[i],
                            point: pointClouds[i].forgeData[j].point,
                            index: j,
                            distanceToRay: distance
                        })
                    }

                }
            }
        }
        
        //remove nodes same as 360 image
        if (store.state.selectedImage && !this.isViewer2d())
            nodes = nodes.filter(o => o.object.forgeData[o.index].object != store.state.selectedImage)
            
        var camPos = this.viewer.navigation.getPosition();
        if (!this.isViewer2d()) {
            var hitTest = this.viewer.clientToWorld(event.offsetX, event.offsetY, false);
            if (hitTest && hitTest.point) {
                let tolerance = 16 / this.viewer.model.getUnitScale();
                for (let i = nodes.length - 1; i >= 0; i--) {
                    if (nodes[i].object.type.includes('Overlay') || nodes[i].object.type.includes('HighlightedPointCloud')) {
                        if (nodes[i].point.distanceTo(camPos) > tolerance)
                            nodes.splice(i, 1);
                    } else {
                        if(nodes[i].point.distanceTo(camPos) > hitTest.point.distanceTo(camPos))
                            nodes.splice(i, 1);
                    }
                }
            }
        }
        //filter nodes within visibility range
        if (!this.isViewer2d())
            nodes = nodes.filter(o => o.point.distanceTo(camPos) < store.state.userSettings.displaySettings.getVisibilityRangeInViewer());

        //distance filter
        if (nodes.length > 0) {
            nodes.sort(function (a, b) {
                return a.distanceToRay - b.distanceToRay;
            })

            let nearestTag = nodes.find(n => n.object.type == "HighlightedPointCloud" && !!n.object.forgeData?.length) || nodes[0];

            this.hoveringPointCloud = nearestTag.object;
            this.hovered = nearestTag.index;
            nearestTag.object.geometry.attributes.color.array[(this.hovered * 3) + 0] = 5.0;
            nearestTag.object.geometry.attributes.color.array[(this.hovered * 3) + 1] = 5.0;
            nearestTag.object.geometry.attributes.color.array[(this.hovered * 3) + 2] = 5.0;
            nearestTag.object.geometry.attributes.color.needsUpdate = true;
            if(this.isViewer2d() && nearestTag.object.forgeData[this.hovered].object
                                 && nearestTag.object.forgeData[this.hovered].object.area2dCoordinates)
                this.hoveringArea = this.drawTagAreaByColor(nearestTag.object.forgeData[this.hovered].object,this.hoveringColor)

            this.viewer.impl.invalidate(false,false,true);
        }
        else
            this.hovered = -1;
    }
    isWithinTolerance(point, target, tolerancePixels) {
        var clientImgPoint = this.viewer.worldToClient(point)
        var clientPointToRay = this.viewer.worldToClient(target)
        return clientImgPoint.distanceTo(clientPointToRay) < tolerancePixels;
    }
    getVisibilityRange() {
        return parseFloat(store.state.userSettings.displaySettings.getVisibilityRangeInViewer());
    }
    clearHighlightingTags() {
        if (!this.viewer || !this.viewer.impl) return;

        let oldPcs = this.viewer.impl?.overlayScenes[this.sceneName]?.scene?.children?.filter(t => t.type == 'HighlightedPointCloud') ?? [];
        if (oldPcs.length) {
            clearInterval(this.selectedPcInterval)
            this.selectedPcInterval = null
            removeFromScene(oldPcs, this.viewer, this.sceneName);
            this.pointClouds = this.pointClouds.filter(pc => pc.type !== 'HighlightedPointCloud');
            this.viewer.impl.invalidate(false, false, true);
        }

    }
    createHighlightingTags(data) {
        if (!data.filter(t => !!t.point || !!t.position).length) return

        console.log(`🔦 Create highlight tag for: `, data)

        this.clearHighlightingTags();
        
        let pointCloud = null;
        
        let highlight = () => {
            if (this.selectedPcInterval) clearInterval(this.selectedPcInterval);

            this.selectedPcInterval = setInterval(() => {
                if(!this.viewer.impl || !this.viewer.impl.overlayScenes) return;

                let o = this.viewer.impl.overlayScenes[this.sceneName].scene.children.find(t => t.type == 'HighlightedPointCloud');

                if (!o) return;

                let u = o.material.uniforms;
                let c = u.textureColor.value;
                u.textureColor.value = new THREE.Vector3(1 / c.x, c.y, 1 / c.z);
                o.geometry.attributes.color.needsUpdate = true;
                this.viewer.impl.invalidate(false, false, true);
            }, 500)
        }

        var geometry = new THREE.BufferGeometry();

        let length = data.length;

        var position = new Float32Array(length * 3);
        var color = new Float32Array(length * 3);
        var position3d = new Float32Array(length * 3);

        let forgeData = [];

        for (let i = 0; i < length; i++) {
            const tag = data[i];
            const p   = tag.point ?? tag.position;

            if (p) {
                let point = this.isViewer2d() ? store.state.selectedLevel.mappingViewersPointsInfo._3dTo2d(p) : tag.getPointInView();
    
                if (this.isViewer2d() && tag instanceof ForgeEquipment) {
                    // [FORGE-684] shift all rendered 2d equipments by fixed value because of an issue of exact overlapping when some inspections/equipments are created by exactly same objects
                    point.x += .001;
                }

                position[(i * 3) + 0] = point.x;
                position[(i * 3) + 1] = point.y;
                position[(i * 3) + 2] = point.z;

                color[(i * 3) + 0] = 3.0;
                color[(i * 3) + 1] = 3.0;
                color[(i * 3) + 2] = 3.0;

                forgeData.push({
                    name: tag.name,
                    thumbnailURL: tag.thumbnailUrl,
                    object: tag,
                    point: point,
                    onClick: (event) => {
                        store.state.forgeService.onClickOn3dIcon(tag, event, this.viewType);
                    }
                })

                if (this.isViewer2d()) point = store.state.selectedLevel.mappingViewersPointsInfo._2dTo3d(point);

                position3d[(i * 3) + 0] = point.x;
                position3d[(i * 3) + 1] = point.y;
                position3d[(i * 3) + 2] = point.z;
            }
        }

        geometry.setAttribute('position', new THREE.BufferAttribute(position, 3));
        geometry.setAttribute('color', new THREE.BufferAttribute(color, 3));
        geometry.setAttribute('position3d', new THREE.BufferAttribute(position3d, 3));
        
        let cameraPosition = this.viewer.navigation.getPosition();
        var texture = this.textures["pin"];

        let textureColor = new THREE.Color(this.hoveringColor);
        textureColor = new THREE.Vector3(textureColor.r,textureColor.g,textureColor.b);

        let hoveringColor = new THREE.Color(0X00FF00);
        hoveringColor = new THREE.Vector3(hoveringColor.r,hoveringColor.g,hoveringColor.b);

        var material = new THREE.ShaderMaterial({
            vertexColors: true,
            vertexShader: this.vertexShader,
            fragmentShader: this.tagsFragmentShader,
            depthWrite: false,
            depthTest: false,
            uniforms: {
                isTag: { type: "i", value: 1 },
                isViewer2d: { type: "i", value: this.isViewer2d() ? 1 : 0 },
                isMISTag:{ type: "i", value: 0 },
                tex: { type: "t", value: texture },
                textureColor: { type: "v3", value: textureColor },
                hoveringTextureColor: { type: "v3", value: hoveringColor },
                visibilityRange: { type: "f", value: Infinity },
                cameraX: { type: "f", value: cameraPosition.x },
                cameraY: { type: "f", value: cameraPosition.y },
                cameraZ: { type: "f", value: cameraPosition.z },
                scaleFactor: { type: "f", value: this.isViewer2d() ? 1.0 : 1 / this.viewer.model.getUnitScale() },
            }
        });

        pointCloud = new THREE.PointCloud(geometry, material);
        
        if(this.isViewer2d()) {
            pointCloud.position.setZ(1);
        } 

        pointCloud.type = 'HighlightedPointCloud';

        if (forgeData.length) {
            pointCloud.forgeData = forgeData;
            pointCloud.isTag = true;
            this.pointClouds.push(pointCloud)
        }
        
        addToScene(pointCloud, this.viewer, this.sceneName);

        setTimeout(() => {
            if(this.viewer && this.viewer.impl) {
                highlight()
            }
        }, 100);
    }
}
Autodesk.Viewing.theExtensionManager.registerExtension('labels3dExt', labels3dExt);
